import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";

export const BusinessUnitsPage: FC = () => {
  return (
    <PageContextWrapper entity="businessUnit">
      <PageClientSideFilters />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
